export type RememberedNavigationArea = "frontend" | "administration";

const AREAS: Record<
  RememberedNavigationArea,
  { storageKey: string; changedEvent: string }
> = {
  frontend: {
    storageKey: "vend:rememberedRoutesBySection",
    changedEvent: "vend:rememberedRoutesChanged",
  },
  administration: {
    storageKey: "vend:administrationRememberedRoutes",
    changedEvent: "vend:administrationRememberedRoutesChanged",
  },
};

export const rememberedNavigationArea = (area: RememberedNavigationArea) =>
  AREAS[area];

export const rememberedNavigationStorageKey = (
  area: RememberedNavigationArea,
  scope: string,
) => {
  const normalizedScope = scope.trim();
  return normalizedScope
    ? `${AREAS[area].storageKey}:${encodeURIComponent(normalizedScope)}`
    : "";
};

export const notifyRememberedNavigationChanged = (
  area: RememberedNavigationArea,
) => {
  try {
    window.dispatchEvent(new CustomEvent(AREAS[area].changedEvent));
  } catch {
    // Ignore unavailable browser APIs.
  }
};

export const clearRememberedNavigation = (
  area?: RememberedNavigationArea,
) => {
  try {
    const selectedAreas = area
      ? [AREAS[area]]
      : Object.values(AREAS);
    const keys = Array.from({ length: localStorage.length }, (_, index) =>
      localStorage.key(index),
    ).filter((key): key is string =>
      Boolean(
        key &&
          selectedAreas.some(
            ({ storageKey }) =>
              key === storageKey || key.startsWith(`${storageKey}:`),
          ),
      ),
    );
    keys.forEach((key) => localStorage.removeItem(key));
    selectedAreas.forEach(({ changedEvent }) => {
      window.dispatchEvent(new CustomEvent(changedEvent));
    });
  } catch {
    // Ignore unavailable storage.
  }
};
